import React, { useState } from 'react';
import { Container, Form, Header, Icon, Breadcrumb, Button, Grid, Radio, Table, Message } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { usePresentationForm } from './usePresentationForm';
import moment from 'moment';

export function EditPresentationForm() {
    let [values, masterData, errors, touched, isLoading, isSubmitting, isValid, submitSuccess, errorMessage, dataLoaded,
        registerRef, handleChange, handleBlur, handleSubmit] = usePresentationForm();

    const history = useHistory();
    const today = moment().format('yyyy-MM-DD');

    function handleBackToList() {
        history.push('/employerSpotlightPresentationList');
    }
    let isPast: boolean = false;
    if (values.presentationDate && moment().isSameOrAfter(moment(values.presentationDate), 'day')) {
        isPast = true;
    }
    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Edit Spotlight Presentation</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section link><Link to={'/employerSpotlightPresentationList'}>Employer Spotlight Presentations</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Edit Spotlight Presentation</Breadcrumb.Section>
        </Breadcrumb>

        <Grid columns={2} style={submitSuccess ? { margin: 0 } : {}}>
            {
                !submitSuccess && !isPast &&
                <Grid.Column>
                    <Form loading={isSubmitting || !dataLoaded}>
                        <Form.Input className={!(!errors.organizationName || !touched.organizationName) ? 'mb-0' : ''}
                            required
                            fluid
                            label='Organization Name'
                            onChange={(event, data) => {
                                handleChange(data.value, 'organizationName');
                            }}
                            onBlur={
                                () => { handleBlur('organizationName') }
                            }
                            value={values.organizationName}
                            error={!(!errors.organizationName || !touched.organizationName) ? true : false}
                        />
                        {
                            !(!errors.organizationName || !touched.organizationName) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.organizationName}</div>
                        }
                        <Form.Input className={!(!errors.presentationTopic || !touched.presentationTopic) ? 'mb-0' : ''}
                            label='Presentation Topic'
                            required
                            onChange={(event, data) => {
                                handleChange(data.value, 'presentationTopic');
                            }}
                            onBlur={
                                () => { handleBlur('presentationTopic') }
                            }
                            value={values.presentationTopic}
                            error={!(!errors.presentationTopic || !touched.presentationTopic) ? true : false}
                        />
                        {
                            !(!errors.presentationTopic || !touched.presentationTopic) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.presentationTopic}</div>
                        }

                        <Form.TextArea className={!(!errors.presentationDescription || !touched.presentationDescription) ? 'mb-0' : ''}
                            label='Presentation Description'
                            onChange={(event, data) => {
                                handleChange(data.value, 'presentationDescription');
                            }}
                            onBlur={
                                () => { handleBlur('presentationDescription') }
                            }
                            value={values.presentationDescription}
                            error={!(!errors.presentationDescription || !touched.presentationDescription) ? true : false}
                        />
                        {
                            !(!errors.presentationDescription || !touched.presentationDescription) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.presentationDescription}</div>
                        }

                        <Form.Input className={!(!errors.presenter || !touched.presenter) ? 'mb-0' : ''}
                            label='Presenter'
                            onChange={(event, data) => {
                                handleChange(data.value, 'presenter');
                            }}
                            onBlur={
                                () => { handleBlur('presenter') }
                            }
                            value={values.presenter}
                            error={!(!errors.presenter || !touched.presenter) ? true : false}
                        />
                        {
                            !(!errors.presenter || !touched.presenter) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.presenter}</div>
                        }

                        <Form.Input className={!(!errors.presentationDate || !touched.presentationDate) ? 'mb-0' : ''}
                            fluid
                            type='date'
                            label='Presentation Date'
                            placeholder='mm/dd/yyyy'
                            required
                            min={today}
                            value={values.presentationDate}
                            onChange={(event, data) => {
                                handleChange(data.value, 'presentationDate');
                            }}
                            onBlur={
                                () => { handleBlur('presentationDate') }
                            }
                            error={!(!errors.presentationDate || !touched.presentationDate) ? true : false}
                        />
                        {
                            !(!errors.presentationDate || !touched.presentationDate) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.presentationDate}</div>
                        }

                        <Form.Input className={!(!errors.startTime || !touched.startTime) ? 'mb-0' : ''}
                            required
                            fluid
                            label='Start Time'
                            onChange={(event, data) => {
                                handleChange(data.value, 'startTime');
                            }}
                            onBlur={
                                () => { handleBlur('startTime') }
                            }
                            placeholder='HH:MM AM/PM'
                            value={values.startTime}
                            error={!(!errors.startTime || !touched.startTime) ? true : false}
                        />
                        {
                            !(!errors.startTime || !touched.startTime) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.startTime}</div>
                        }

                        <Form.Input className={!(!errors.endTime || !touched.endTime) ? 'mb-0' : ''}
                            required
                            fluid
                            label='End Time'
                            placeholder='HH:MM AM/PM'
                            onChange={(event, data) => {
                                handleChange(data.value, 'endTime');
                            }}
                            onBlur={
                                () => { handleBlur('endTime') }
                            }
                            value={values.endTime}
                            error={!(!errors.endTime || !touched.endTime) ? true : false}
                        />
                        {
                            !(!errors.endTime || !touched.endTime) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.endTime}</div>
                        }
                        <Form.Group inline className={!(!errors.presentationModeCode || !touched.presentationModeCode) ? 'mb-0' : ''}>
                            <label>Presentation Mode<span style={{ color: '#db2828', margin: '-0.2em 0 0 0.2em' }}>*</span></label>
                            {
                                masterData && masterData.map((item: any, index: number) => {
                                    return (<Form.Field
                                        key={index}
                                        control={Radio}
                                        label={item.displayName}
                                        value={item.presentationModeCode}
                                        checked={values.presentationModeCode == item.presentationModeCode}
                                        onChange={(event: any, data: any) => {
                                            let newValue = (data as { value: any }).value;
                                            handleChange(newValue, 'presentationModeCode', false);
                                        }}
                                        error={!(!errors.presentationModeCode || !touched.presentationModeCode) ? true : false}
                                    />);
                                })
                            }
                        </Form.Group>
                        <Form.TextArea className={!(!errors.location || !touched.location) ? 'mb-0' : ''}
                            label='Location'
                            required={values.presentationModeCode !== 'OL'}
                            onChange={(event, data) => {
                                handleChange(data.value, 'location');
                            }}
                            onBlur={
                                () => { handleBlur('location') }
                            }
                            value={values.location}
                            error={!(!errors.location || !touched.location) ? true : false}
                        />
                        {
                            !(!errors.location || !touched.location) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.location}</div>
                        }

                        <Form.TextArea className={!(!errors.notes || !touched.notes) ? 'mb-0' : ''}
                            label='Notes'
                            onChange={(event, data) => {
                                handleChange(data.value, 'notes');
                            }}
                            onBlur={
                                () => { handleBlur('notes') }
                            }
                            value={values.notes}
                            error={!(!errors.notes || !touched.notes) ? true : false}
                        />
                        {
                            !(!errors.notes || !touched.notes) &&
                            <div className='error-message'><Icon name='warning sign' color='orange' /> {errors.notes}</div>
                        }



                        <Button type='button' loading={isSubmitting} primary onClick={handleSubmit}>Save</Button>
                        <Button type='button' onClick={() => { history.goBack() }}>Cancel</Button>
                    </Form>
                </Grid.Column>
            }
            {
                isPast &&
                <>
                    <Table padded striped style={{marginTop:'1.0rem'}}>
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}><b>Organization Name</b></Table.Cell>
                                <Table.Cell>{values.organizationName}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Presentation Topic</b></Table.Cell>
                                <Table.Cell>{values.presentationTopic}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Description</b></Table.Cell>
                                <Table.Cell>{values.presentationDescription}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Presenter</b></Table.Cell>
                                <Table.Cell>{values.presenter}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Presentation Date</b></Table.Cell>
                                <Table.Cell>{values.presentationDate}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Start Time</b></Table.Cell>
                                <Table.Cell>{values.startTime}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>End Time</b></Table.Cell>
                                <Table.Cell>{values.endTime}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Presentation Mode</b></Table.Cell>
                                <Table.Cell>{masterData && masterData.filter((item) => { return item.presentationModeCode == values.presentationModeCode })[0].displayName}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Location</b></Table.Cell>
                                <Table.Cell>{values.location}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell width={4}><b>Notes</b></Table.Cell>
                                <Table.Cell>{values.notes}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                    <Button type='button' onClick={() => { history.goBack() }}>Back</Button>
                </>
            }
            {
                submitSuccess &&
                <Message icon positive>
                    <Icon name='check circle outline' color='green' />
                    <Message.Content>
                        <Message.Header>Success</Message.Header>
                        <div>Thank you for editing a presentation. This presentation has been updated.</div>
                        <div style={{ marginTop: '0.5rem' }}>
                            <Button icon labelPosition='left' size='small' onClick={handleBackToList}>
                                <Icon name='arrow circle left' />
                                <span>Back to Employer Spotlight Presentations</span>
                            </Button></div>
                    </Message.Content>
                </Message>
            }

        </Grid>

    </Container>
}